export default __webpack_public_path__ + "static/media/quote-img.ad2450fa.png";